import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import { getBins } from '../../../redux/binsRedux';
import { getBeers } from '../../../redux/beersRedux';
import { addRepairOrderRequest } from '../../../redux/repairOrdersRedux';
import { Link, useSearchParams } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const RepairOrder = ({ orders, naglowek, buttonText, temat, sliderBool }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [dedicatedOrder, setDedicatedOrder] = useState(
    searchParams.get('reportId') || null,
  );
  const [open, setOpen] = useState(searchParams.get('openRepair') === 'true');
  const [beerDes, setBeerDes] = useState('');
  const [orderProductId, setOrderProductId] = useState('');
  const [product, setProduct] = useState('');
  const [totalPallets, setTotalPallets] = useState(0);
  const [sourceBins, setSourceBins] = useState([]);
  const [currentBinId, setCurrentBinId] = useState('');
  const [currentBinName, setCurrentBinName] = useState('');
  const [currentBinQuantity, setCurrentBinQuantity] = useState(0);
  const [casBinQuantity, setCasBinQuantity] = useState(0);

  const [batch, setBatch] = useState('');

  const user = useSelector((state) => getUser(state));
  const bins = useSelector((state) => getBins(state));
  const products = useSelector((state) => getBeers(state));
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeStatusName = (status) => {
    switch (status) {
      case 'OPEN':
        return 'Otwarty';
      case 'IN_PROGRESS':
        return 'W trakcie';
      case 'FINALIZED':
        return 'Zamknięty';
      default:
        return 'Nieznany status';
    }
  };

  const handleSubmit = async () => {
    // Implement the logic to handle form submission
    const newOrder = {
      productId: orderProductId,
      batch,
      createdById: user.users.id,
      totalPallets, // Assuming you want to set this to 0 initially
      sourceBins,
      reportPZ04Id: dedicatedOrder,
    };
    const res = await dispatch(addRepairOrderRequest(newOrder));
    console.log('New repair order created:', res.data);
    handleClose();
  };

  const handleProduct = async (id) => {
    if (id !== '') {
      products.map((el) => {
        if (el.id === id) {
          setProduct(el);
        }
      });
    } else {
      setProduct('');
    }
  };

  const handleAddBin = () => {
    const quantity =
      parseInt(currentBinQuantity) * product.palletQty +
      parseInt(casBinQuantity);

    setTotalPallets((prev) => prev + parseInt(quantity));
    console.log(totalPallets);
    const newBin = {
      binId: currentBinId,
      binName: currentBinName,
      quantity: quantity,
    };

    setSourceBins((prev) => [...prev, newBin]);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6">{naglowek}</Typography>
        <Button
          sx={{ visibility: sliderBool ? 'hidden' : 'visible' }}
          onClick={handleOpen}
          variant="outlined"
        >
          {buttonText}
        </Button>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '15%' }}>Materiał</TableCell>
            <TableCell sx={{ width: '55%' }}>Opis materiału</TableCell>
            <TableCell sx={{ width: '15%' }}>Partia</TableCell>
            <TableCell sx={{ width: '55%' }}>Ilość początkowa</TableCell>
            <TableCell sx={{ width: '55%' }}>Ilość pozostała</TableCell>
            <TableCell sx={{ width: '15%' }}>Status</TableCell>
            <TableCell
              sx={{
                width: '15%',
                visibility: sliderBool ? 'hidden' : 'visible',
              }}
            >
              Akcja
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders && orders.length > 0 ? (
            orders.map((order) => (
              <TableRow key={order.id}>
                <TableCell>{order.materialNumber}</TableCell>
                <TableCell>{order.productName}</TableCell>
                <TableCell>{order.batch}</TableCell>
                <TableCell>
                  {(order.totalPallets -
                    (order.totalPallets % order.palletQty)) /
                    order.palletQty}
                </TableCell>
                <TableCell>
                  {(order.remainingQuantity -
                    (order.remainingQuantity % order.palletQty)) /
                    order.palletQty}
                </TableCell>
                <TableCell>{handleChangeStatusName(order.status)}</TableCell>
                <TableCell
                  sx={{ visibility: sliderBool ? 'hidden' : 'visible' }}
                >
                  <Button
                    variant="contained"
                    component={Link}
                    to={`/repair-order/${order.id}`}
                  >
                    Otwórz
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center">
                <Typography
                  sx={{ fontWeight: 'bold' }}
                  variant="body2"
                  color="black"
                >
                  {temat}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {buttonText}
          </Typography>

          {products.length > 0 && (
            <Box sx={{ mt: 2, display: 'flex' }}>
              <Autocomplete
                disablePortal
                id="combo-source"
                options={products.map((el) => ({
                  id: el.id,
                  label: `${el.materialNumber} ${el.description}`,
                }))}
                value={beerDes}
                sx={{ width: { xs: '100%', md: '50%' }, mb: 2, mx: 1 }}
                onChange={(e, value) => {
                  setOrderProductId(value ? value.id : '');
                  setBeerDes(value ? value.label : '');
                  handleProduct(value ? value.id : '');
                  //   handleProduct(value ? value.id : '');
                }}
                renderInput={(params) => (
                  <TextField {...params} label={'Wyrób gotowy'} />
                )}
              />
              <TextField
                label="Partia"
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                value={batch}
                onChange={(e) => setBatch(e.target.value)}
              />
              <TextField
                label="Ilość [cas]"
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                value={totalPallets}
                disabled
              />
            </Box>
          )}
          <Box sx={{ mt: 2, display: 'flex' }} component={'form'}>
            <Autocomplete
              disablePortal
              id="combo-source"
              sx={{ width: { xs: '50%', md: '20%' }, mb: 2, mx: 1 }}
              options={bins.map((el) => ({
                id: el.id,
                label: `${el.binName}`,
              }))}
              value={currentBinName}
              onChange={(e, value) => {
                setCurrentBinId(value ? value.id : '');
                setCurrentBinName(value ? value.label : '');
              }}
              renderInput={(params) => (
                <TextField {...params} label={'Lokalizacja'} />
              )}
            />
            <TextField
              label="Ilość palet"
              sx={{ width: { xs: '100%', md: '20%' }, mb: 2, mx: 1 }}
              value={currentBinQuantity}
              onChange={(e) => setCurrentBinQuantity(e.target.value)}
            />
            <TextField
              label="Ilość końcowki"
              sx={{ width: { xs: '100%', md: '20%' }, mb: 2, mx: 1 }}
              value={casBinQuantity}
              onChange={(e) => setCasBinQuantity(e.target.value)}
            />
            <Button
              variant="contained"
              sx={{
                mt: 1,
                height: '40px',
                width: { xs: '100%', md: '20%' },
                bgcolor: '#C09A53',
                ':hover': { bgcolor: '#9c7c43' },
              }}
              onClick={handleAddBin}
            >
              Dodaj
            </Button>
          </Box>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Lokalizacja</TableCell>
                <TableCell>Ilość palet</TableCell>
                <TableCell>Ilość końcówki</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sourceBins.length > 0 ? (
                sourceBins.map((el) => (
                  <TableRow key={el.binId}>
                    <TableCell>{el.binName}</TableCell>
                    <TableCell>
                      {Math.floor(el.quantity / product.palletQty)}
                    </TableCell>
                    <TableCell>{el.quantity % product.palletQty}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <Typography
                      sx={{ fontWeight: 'bold' }}
                      variant="body2"
                      color="black"
                    >
                      Brak dodanych lokalizacji
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Button
            variant="contained"
            sx={{
              mt: 2,
              bgcolor: '#C09A53',
              ':hover': { bgcolor: '#9c7c43' },
            }}
            onClick={handleSubmit}
          >
            Utwórz
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default RepairOrder;
